import { HttpClient } from "@angular/common/http";
import { CreateClient, UpdateClient } from "../interfaces/client.interface";
import { Injectable, forwardRef, inject } from "@angular/core";
import { Observable } from "rxjs";
import { Client } from "../interfaces/client.interface";
import { API_URL } from '@equine-ui-nx/injection-tokens';

@Injectable()
export class ClientService {
  apiUrl = inject(forwardRef(() => API_URL));
  baseUrl = `${this.apiUrl}/clients`;
  http = inject(HttpClient);

  create(payload: CreateClient): Observable<{id: string}> {
    return this.http.post<{id: string}>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdateClient): Observable<any> {
    return this.http.post(`${this.baseUrl}/update/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/delete/${id}`, {});
  }

  getAll(): Observable<Client[]> {
    return this.http.get<Client[]>(`${this.baseUrl}`);
  }
}